import CardHeading from '@commons/headings/card'
import Column from '@components/column'
import Row from '@components/row'
import { StyleGrid } from './style'
import { Appointment } from '@apis'
import { useSelector } from 'react-redux'
import { Fragment, useEffect } from 'react'
import InstantAppointmentRequestCard from '@commons/cards/instantAppointmentRequest'
import InstantAppointmentRequestCardLoader from '@commons/cards/instantAppointmentRequest/loader'
import Empty from '@commons/empty'
import useInstantAppointmentActions from '@hooks/useInstantAppointmentActions'
import Alert from '@commons/popups/alert'

const RequestInstantAppointments = () => {
  const { items: appointments, loading } = useSelector(
    (state: any) => state.instantConsultAppointments,
  )

  const {
    visible,
    loading: alertLoading,
    alertInfo,
    handleClickBtn,
    handleClickYes,
    handleClose,
  } = useInstantAppointmentActions({
    selector: 'instantConsultAppointments',
  })

  const fetchData = async () => {
    await Appointment.list({
      params: {
        isInstant: true,
        status: 'Pending',
      },
      action: 'set',
      state: 'instantConsultAppointments',
    }).catch(() => {})
  }

  useEffect(() => {
    if (!appointments?.length) {
      fetchData()
    }
  }, [])
  return (
    <>
      <Column rowGap={20}>
        <Row justifyContent="space-between">
          <CardHeading tc={'primary'} title="Request List" />
        </Row>

        {!!loading ? (
          <StyleGrid>
            {Array(6)
              ?.fill(0)
              ?.map((_: any, index: number) => {
                return (
                  <Fragment key={index}>
                    <InstantAppointmentRequestCardLoader />
                  </Fragment>
                )
              })}
          </StyleGrid>
        ) : (
          <>
            {!!appointments?.length ? (
              <StyleGrid onClick={handleClickBtn}>
                {appointments?.map((appointment: any, index: number) => {
                  return (
                    <Fragment key={index}>
                      <InstantAppointmentRequestCard
                        appointment={appointment}
                      />
                    </Fragment>
                  )
                })}
              </StyleGrid>
            ) : (
              <>
                <Empty />
              </>
            )}
          </>
        )}
      </Column>
      {alertInfo?.type == 'confirm' && !!visible && (
        <Alert
          title={'Confirmed Request'}
          visible={visible}
          description="Are you sure you want to confirmed request ?"
          onClickOk={handleClickYes}
          onClickClose={handleClose}
          loading={alertLoading}
        />
      )}

      {alertInfo?.type == 'queue' && !!visible && (
        <Alert
          title={'Add to Queue'}
          visible={visible}
          description="Are you sure you want to add to queue?"
          onClickOk={handleClickYes}
          onClickClose={handleClose}
          loading={alertLoading}
        />
      )}
    </>
  )
}

export default RequestInstantAppointments
